import {
    Component,
    EventEmitter,
    Input,
    Output,
    ViewEncapsulation,
} from "@angular/core";

import { ExportDownloadService } from "../../../core/providers/export-download/export-download.service";
import { DropdownComponent } from "../dropdown/dropdown.component";
import {
    COMPACT_EXPORT_FORMAT_OPTIONS,
    COPY_SHARE_LINK_LABEL,
    EXPORT_FORMAT_OPTIONS,
    ExportFormat,
} from "../../types/export-format.types";

@Component({
    selector: "vsf-export-download-menu",
    templateUrl: "./export-download-menu.component.html",
    styleUrls: ["./export-download-menu.component.scss"],
    encapsulation: ViewEncapsulation.None,
})
export class ExportDownloadMenuComponent {
    @Input() label = "Download";
    @Input() buttonClass = "";
    @Input() iconSrc?: string;
    @Input() showDefaultIcon = false;
    @Input() ariaLabel = "Download";
    @Input() dropdownPosition: ("bottom" | "bottom-right" | "bottom-left")[] = [
        "bottom-left",
    ];
    @Input() showShareLink = false;
    @Input() skipFormatPicker = false;
    @Input() compactMenu = false;

    @Output() download = new EventEmitter<ExportFormat>();
    @Output() shareLink = new EventEmitter<ExportFormat>();

    readonly defaultOptions = EXPORT_FORMAT_OPTIONS;
    readonly compactOptions = COMPACT_EXPORT_FORMAT_OPTIONS;
    private readonly defaultIconSrc = "assets/icons/download-icon.svg";

    constructor(private exportDownloadService: ExportDownloadService) {}

    get menuOptions(): { value: ExportFormat; label: string }[] {
        return this.compactMenu ? this.compactOptions : this.defaultOptions;
    }

    readonly shareLinkLabel = COPY_SHARE_LINK_LABEL;

    get resolvedIconSrc(): string | undefined {
        if (this.iconSrc) {
            return this.iconSrc;
        }
        if (this.showDefaultIcon) {
            return this.defaultIconSrc;
        }
        return undefined;
    }

    emitImmediateDownload(): void {
        this.download.emit(this.exportDownloadService.getPreferredFormat());
    }

    selectFormat(format: ExportFormat, dropdown: DropdownComponent): void {
        this.exportDownloadService.setPreferredFormat(format);
        dropdown.close();
        this.download.emit(format);
    }

    copyShareLink(dropdown: DropdownComponent): void {
        const format = this.exportDownloadService.getPreferredFormat();
        dropdown.close();
        this.shareLink.emit(format);
    }
}
